import { languageService } from "../../../../Language/language.service";
import { arrayToSelectOptions } from "../../../../utils/arrayToSelectOptions";
import { isFraRole } from "../../../MainPage/UserInfo";

export const hosMistakenSearchFiltersFormSchema = {
  title: languageService("Search Mistaken HOS Records"),
  id: "hosSearchFiltersFormSchema",
  returnOnlyEnabledFields: false,
  stateTitle: {},
  sections: [
    {
      id: "typeSelectionSection",
      fields: [
        {
          id: "employeeEmail", // required
          type: "select", // required
          labelValue: languageService("Employee"),
          required: true,
          selectOptions: [],
          col: 4,
        },
      ],
    },

    {
      id: "footerActionsSection",
      fields: [
        {
          id: "searchRecords",
          type: "button",
          labelValue: languageService("Search"),
          action: "submit",
          callback: "searchRecords",
          position: "footer",
          col: 12,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/components/HoursOfService/HosMistakenReport/schemas/hosSearchFiltersFormSchema.js